<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="标题">
                    <el-input v-model="search.title" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index" width="80"></el-table-column>
                <el-table-column prop="Title" label="标题" width></el-table-column>
                <el-table-column prop="ImageUrl" label="邀请函链接" width>
                    <template slot-scope="scope">
                        <span v-if="scope.row.ImageUrl!=null">
                            <el-popover placement="left" trigger="click" style="width:400px;cursor:pointer;">
                                <img :src="scope.row.ImageUrl" width="100%" />
                                <img slot="reference" :src="scope.row.ImageUrl" :alt="scope.row.ImageUrl"
                                    width="60" height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Content" label="描述内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Sort" label="排序" width></el-table-column>
                <!-- <el-table-column prop="BrandType" label="品牌" width></el-table-column> -->
                <el-table-column prop="ActivityTitle" label="活动主题" width="150"></el-table-column>
                <el-table-column prop="PageTypeString" label="页面类型" width="120"></el-table-column>
                <el-table-column prop="ModifyTimeString" label="最后修改时间" width></el-table-column>
                <el-table-column prop="Enabled" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled==true ? 'success' : 'danger'" disable-transitions>{{
                            scope.row.Enabled==true ? "启用" : "停用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('update') != -1).length > 0"
                            @click="update(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small"   v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0"
                            @click="handledel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>


        <!--修改界面-->
        <el-dialog title="数据修改" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                <el-form-item label="标题" prop="Title">
                    <el-input v-model="editForm.Title" type="Text" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="邀请函链接" prop="ImageUrl">
                   <el-input v-model="editForm.ImageUrl" type="textarea" :rows="2" auto-complete="off"></el-input>
                    <!-- <ImageFile :value="imgList" :imgLimit="1" @change="imageChange"></ImageFile> -->
                </el-form-item>
                <el-form-item label="品牌标识" prop="BrandType">
                    <selectPBBrand style="width: 100%" v-model="editForm.BrandType">
                    </selectPBBrand>
                </el-form-item>
                <el-form-item label="所属活动" prop="ActivityId">
                    <el-select v-model="editForm.ActivityId" placeholder="请选择活动" style="width: 100%">
                        <el-option
                            v-for="item in activityList"
                            :key="item.Id"
                            :label="item.Title"
                            :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="页面类型" prop="PageType">
                    <el-radio-group v-model="editForm.PageType">
                        <el-radio :label="1">报名页面</el-radio>
                        <el-radio :label="2">结束展示页</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="描述内容" prop="Content">
                    <el-input v-model="editForm.Content" type="textarea" :rows="3" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Enabled">
                    <el-radio-group v-model="editForm.Enabled">
                        <el-radio :label="true" checked>启用</el-radio>
                        <el-radio :label="false">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="Sort">
                    <el-input v-model="editForm.Sort" type="number" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {getButtonList} from "../../../promissionRouter";
    import {getInvitationManagePageList,PostInvitationManage,removeInvitationManage,GetActiveActivityList} from '../../../api/api';
    export default {
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:30,
                listLoading: false,
                data:[],

                //修改
                editFormVisible:false,
                editLoading:false,
                editForm:{
                    Id: 0,
                    Enabled:true,
                    Title:'',
                    Content:'',
                    ImageUrl:null,
                    ImageUrlPath:null,
                    BrandType:'',
                    Sort:0,
                    ActivityId:null,
                    PageType:1
                },
                editFormRules: {
                    Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
                    BrandType:[{ required: true, message: "请选择品牌", trigger: "change" }]
                },
                imgList:[],
                IsAdd:true,
                activityList:[]
            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },
            imageChange(val)
            {
                this.imgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'ImageUrl',null);
                }
            },
            getInvitationManagePageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getInvitationManagePageList(para).then((res) => {
                    console.log(res);
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getInvitationManagePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getInvitationManagePageList();
            },
            //查询
            query()
            {
               console.log("查询")
               this.page = 1;
               this.getInvitationManagePageList();
            },
            //删除
            handledel(row)
            {
                console.log(row);
                 this.$confirm("确认删除该邀请函吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    console.log(para);
                    this.listLoading = true;
                    removeInvitationManage(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getInvitationManagePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
                this.editForm = {
                    Id: 0,
                    Enabled:true,
                    Title:'',
                    Content:'',
                    ImageUrl:null,
                    ImageUrlPath:null,
                    BrandType:'',
                    Sort:0,
                    ActivityId:null,
                    PageType:1
                };
                this.imgList =[];
                this.IsAdd = true;
                this.getActiveActivityList();
                this.editFormVisible=true;
            },
            //编辑
            update(row){
                this.editForm = Object.assign({}, row);
                this.imgList = row.ImageUrlPath?[{url: row.ImageUrlPath}]:[];
                this.IsAdd = false;
                this.getActiveActivityList();
                this.editFormVisible=true;
            },
            getActiveActivityList() {
                GetActiveActivityList().then((res) => {
                    if (res.data.success) {
                        this.activityList = res.data.response || [];
                    }
                });
            },
            editSubmit() {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            const formData = new FormData();

                            formData.append("model", JSON.stringify(para));
                            PostInvitationManage(formData).then((res) => {
                                this.editLoading = false;
                                if (res.data.success) {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.editFormVisible = false;
                                    this.getInvitationManagePageList();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });
                    } else {
                        return true;
                    }

                })

            }

        },
        mounted() {
            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.getInvitationManagePageList();
        }
    }

</script>

<style>
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
